import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dialog } from "@mui/material";
import {
  getBlockData,
  unBlockUser,
} from "firebase_/firebase_function/firebase_user";
import { useEffect, useState } from "react";
import ReactModal from "react-modal";
import { useUser } from "util/context/user_context";
import { formatDateTime, maskMiddleCharacters } from "util/function/function";
import ConfirmDialog from "./confirm_dialog";

const BlockUserModal = ({ isOpen, setIsOpen }) => {
  const [blockUserList, setBlockUserList] = useState([]);
  const [selectUserDocId, setSelectUserDocId] = useState(null);
  const { userData } = useUser();
  const [confirmModal, setConfirmModal] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      await getBlockData(userData.docId, setBlockUserList);
    };
    fetchData();
  }, []);

  const closeModal = () => {
    if (window.location.pathname === "/community") {
      sessionStorage.removeItem("page_/community");
      sessionStorage.removeItem("pageIndex_/community");
      sessionStorage.removeItem("pagination_groupData_/community");
      window.location.reload();
    }
    setIsOpen(false);
  };

  const handleUnblockUser = async () => {
    const result = await unBlockUser(userData.docId, selectUserDocId);
    if (result) {
      setBlockUserList((prev) =>
        prev.filter((item) => item.docId !== selectUserDocId)
      );
    }
  };

  return (
    <>
      <Dialog
        open={isOpen}
        onClose={closeModal}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: 3,
          },
        }}
      >
        <div
          className="md:w-[420px] w-[320px]"
          style={{
            height: "600px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            className="f20_1F2937_W600"
            style={{
              borderBottom: "1px solid #E5E7EB",
              padding: "18px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            차단목록
            <button
              type="button"
              onClick={() => {
                closeModal();
              }}
            >
              <FontAwesomeIcon icon={faXmark} size="md" color="#6B7280" />
            </button>
          </div>
          <div style={{ flex: 1, overflowY: "auto" }}>
            {blockUserList.length > 0 ? (
              blockUserList.map((user) => (
                <>
                  <div
                    key={user.id}
                    className="f16_111827_W500"
                    style={{
                      padding: "18px",
                      borderBottom: "1px solid #E5E7EB",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>
                      <div>{maskMiddleCharacters(user.name)}</div>
                      <div className="f14_6B7280_W400">
                        차단일자 : {formatDateTime(user.createDate)}
                      </div>
                    </div>
                    <button
                      className="hover:bg-black/10 transition-all active:bg-black/10 f16_1F2937_W500"
                      style={{ padding: "0px 20px", borderRadius: "8px" }}
                      onClick={() => {
                        setSelectUserDocId(user.docId);
                        setConfirmModal(true);
                      }}
                    >
                      차단해제
                    </button>
                  </div>
                </>
              ))
            ) : (
              <div
                className="f16_111827_W500"
                style={{
                  padding: "12px",
                  textAlign: "center",
                  height: "100%",
                  alignContent: "center",
                }}
              >
                차단된 유저가 없습니다.
              </div>
            )}
          </div>
        </div>
      </Dialog>
      <ConfirmDialog
        open={confirmModal}
        onClose={() => setConfirmModal(false)}
        onConfirm={() => {
          handleUnblockUser();
          setConfirmModal(false);
        }}
        message={"사용자를 차단 해제하시겠습니까?"}
      />
    </>
  );
};

export default BlockUserModal;
